<template>
    <v-menu
          ref="menu1"
          v-model="menu1"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
         <template v-slot:activator="{ on: activatorOn }">
           <ValidationProvider :name="label" :rules="rules" v-slot="{ errors }">
            <v-text-field
              v-model="innerValue"
              :append-icon="prependIcon"
              v-on="{ ...$listeners, ...activatorOn }"
              v-bind="$attrs"
              :label="label"
              :readonly="$attrs.readonly"
              :error-messages="errors"
              autocomplete="off"
              @blur="formatDate"
            ></v-text-field>
            </ValidationProvider>
          </template>
          <v-date-picker
            v-model="pickerDate"
            v-bind="$attrs"
            :type="month ? 'month': 'date'"
            no-title
            @input="menu1 = false"
            :locale="$i18n.locale"
          ></v-date-picker>
        </v-menu>
</template>

<script>
import { ValidationProvider } from "vee-validate";
export default {
  components: {
    ValidationProvider,
  },
  props: {
    rules: {
      type: [Object, String],
      default: "",
    },
    value: {
      type: null,
    },
    month: {
      type: Boolean,
      default: false
    },
    label: String,
    prependIcon: {
      type: String,
      default: "mdi-calendar",
    },
  },
  data() {
    return {
      menu1: false,
      innerValue: null,
      pickerDate: null,
      // dateFormatted: month ? this.formatDate(new Date().toISOString().substr(0, 10)),
    }
  },
  methods: {
    formatDate () {
      if(!this.innerValue){
        this.innerValue = null;
        this.pickerDate = null;
      } else {
        if(!this.month) {
          let dt =this.$moment(this.innerValue).format('YYYY-MM-DD');
          if(!this.innerValue || this.innerValue.length < 8 || this.innerValue.length > 10 || "Invalid date" == dt) {
            dt= null;
          } 
          this.innerValue = dt;
          this.pickerDate = dt;
        }else {
          let dt =this.$moment(`${this.innerValue.substring(0,4)}-${this.innerValue.substring(4,7)}`).format('YYYY-MM');
          if(!this.innerValue || this.innerValue.length < 6 || this.innerValue.length > 7 || "Invalid date" == dt) {
            dt= null;
          } 
          this.innerValue = dt;
          this.pickerDate = dt;
        }
      }
    },
  },
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      this.$emit("input", newVal);
    },
    pickerDate(newVal) {
      this.innerValue = newVal;
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal;
      this.pickerDate = this.value;
    },
  },
  created() {
    if (this.value) {
      this.innerValue = this.value;
      this.pickerDate = this.value;
    }
  },
};
</script>
<style >
  input[type="date"]::-webkit-calendar-picker-indicator {
    background: none;
  }
</style>